import cmsParser from 'Common/util/cmsParser';
import type { PageEntry, Node } from 'contensis-delivery-api';

import type { Props } from './ProspectusesAndPublications';

export type PageData = {
    entry: PageEntry;
    ancestors: Node[];
};

const datamap = (data: PageData): Props => {
    const { entry, ancestors } = data;

    const {
        title,
        sys,
        // Hero Banner
        heroBannerWaveDefaultCondensed,
        // Prospectus Cards
        prospectusDownload,
        // Promo Point
        courseBrochuresTitle,
        courseBrochuresImages,
        courseBrochuresDescription,
        courseBrochuresCTA,
        // Other Brochure Cards
        otherBrochureDownloads
    } = entry;

    return {
        breadcrumbs: cmsParser.breadcrumbs([...ancestors, { entry: { title: title }, id: sys.id }]),
        heroBanner: {
            ...cmsParser.heroBannerWave(heroBannerWaveDefaultCondensed),
            oneColumn: true,
            condensed: true
        },
        prospectusCards:
            prospectusDownload.length > 0
                ? prospectusDownload.map((card, index) => ({
                      header: card.brochureTitle,
                      image: cmsParser.image(card.image),
                      text: card.description,
                      link: cmsParser.linkButton(card.buttonCTA),
                      id: card.brochureTitle + ' ' + index,
                      backgroundColourGrey: card.backgroundColourGrey
                  }))
                : undefined,
        brochurePromoPoint: {
            id: 'Brochure promopoint',
            header: courseBrochuresTitle,
            images: courseBrochuresImages.map(image => cmsParser.image(image)),
            text: courseBrochuresDescription,
            link: cmsParser.linkButton(courseBrochuresCTA)
        },
        otherBrochureCards:
            otherBrochureDownloads.length > 0
                ? otherBrochureDownloads.map((card, index) => ({
                      header: card.brochureTitle,
                      image: cmsParser.image(card.image),
                      text: card.description,
                      link: cmsParser.linkButton(card.buttonCTA),
                      id: card.brochureTitle + ' ' + index,
                      backgroundColourGrey: card.backgroundColourGrey
                  }))
                : undefined
    };
};

export default datamap;
